import * as material from "@mui/material/locale";
import { Localization as MaterialLocalization } from "@mui/material/locale";
import * as datagrid from "@mui/x-data-grid/locales";
import { Localization as DataGridLocalization } from "@mui/x-data-grid/utils/getGridLocalization";
import * as datefns from "date-fns/locale";
import {
    KeyPrefix,
    Namespace,
    UseTranslationResponse,
    useTranslation,
} from "react-i18next";

export type SupportedLocales = "nl" | "en";

export const DefaultLocale: SupportedLocales = "nl";

export interface ApplicationLocale {
    material: MaterialLocalization;
    datagrid: DataGridLocalization;
    datefns: Locale;
}

export const Locales: Record<string, ApplicationLocale> = {
    en: {
        material: material.enUS,
        datagrid: datagrid.enUS,
        datefns: datefns.enUS,
    },
    nl: {
        material: material.nlNL,
        datagrid: datagrid.nlNL,
        datefns: datefns.nl,
    },
};

type UseLocalesResponse<
    N extends Namespace<string>,
    TKPrefix = undefined,
> = UseTranslationResponse<N, TKPrefix> & {
    libraries: ApplicationLocale;
};

export function useLocales<
    N extends Namespace<string> = "translation",
    TKPrefix extends KeyPrefix<N> = undefined,
>(): UseLocalesResponse<N, TKPrefix> {
    const useTsResponse = useTranslation<N, TKPrefix>();
    const response = useTsResponse as UseLocalesResponse<N, TKPrefix>;
    response.libraries = Locales[useTsResponse.i18n.language];
    return response;
}
